import { render, staticRenderFns } from "./WalletCard.vue?vue&type=template&id=c6263980&scoped=true"
import script from "./WalletCard.vue?vue&type=script&lang=js"
export * from "./WalletCard.vue?vue&type=script&lang=js"
import style0 from "./WalletCard.vue?vue&type=style&index=0&id=c6263980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6263980",
  null
  
)

export default component.exports